<template>
  <div>
    <CoolLightBox
      :items="gallery"
      :index="index"
      @close="index = null"
    />

    <div class="flex lg:-mt-40 lg:-mt-96 lg:space-x-5">
      <div
        class="w-full"
        :class="hasSidebar ? 'lg:w-9/12' : ''"
      >
        <div class="relative lg:w-full lg:h-full">
          <iframe
            v-if="galleryData.vr"
            class="absolute top-0 left-0 hidden w-full h-full lg:block"
            :src="galleryData.vr"
          />
          <a
            v-else
            href="#"
            class="relative hidden w-full h-full group lg:block"
            @click.prevent="index = 0"
          >
            <div
              class="absolute z-10 w-full h-full transition duration-200 bg-black opacity-0 group-hover:opacity-20"
            />
            <div class="aspect-ratio-16/9" />
            <img
              :alt="galleryData.title"
              :data-src="galleryData.images[0].sizes['large']"
              class="absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy"
            >
          </a>

          <a
            href="#"
            class="relative block w-full h-full -mt-48 group lg:hidden"
            @click.prevent="index = 0"
          >
            <div
              class="absolute z-10 w-full h-full transition duration-200 bg-black opacity-0 group-hover:opacity-20"
            />
            <div class="aspect-ratio-4/3" />
            <img
              :alt="galleryData.title"
              :data-src="galleryData.images[0].sizes['large']"
              class="absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy"
            >
          </a>
        </div>
      </div>

      <div
        v-if="hasSidebar"
        class="hidden w-3/12 lg:block"
      >
        <div class="space-y-5">
          <a
            v-for="(thumbnail, i) in thumbnails"
            :key="i"
            :href="thumbnail.sizes.large"
            class="relative block text-white group text-shadow"
            @click.prevent="galleryData.vr ? (index = i) : (index = i + 1)"
          >
            <div
              v-if="hasMoreImages && i === thumbnails.length - 1"
              class="absolute z-20 flex items-center justify-center w-full h-full "
            >
              <p class="font-serif text-6xl">+{{ hasMoreImages }}</p>
            </div>
            <div
              v-if="hasMoreImages && i === thumbnails.length - 1"
              class="absolute z-10 w-full h-full transition duration-200 bg-opacity-80 opacity-90 bg-brand-500 group-hover:opacity-50"
            />
            <div
              v-else
              class="absolute z-10 w-full h-full transition duration-200 bg-opacity-50 opacity-0 bg-brand-500 group-hover:opacity-50"
            />
            <div class="aspect-ratio-16/9" />
            <img
              :alt="galleryData.title"
              :data-src="thumbnail.sizes.thumbnail"
              class="absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy"
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import LazyLoad from "vanilla-lazyload";

export default {
  components: {
    CoolLightBox,
  },
  data() {
    return {
      index: null,
      galleryData: window.galleryData,
    };
  },
  computed: {
    thumbnails() {
      let results = [];
      if (this.galleryData.vr) {
        results = this.galleryData.images.slice(0, 3);
      } else {
        results = this.galleryData.images.slice(1, 4);
      }
      return results;
    },
    gallery() {
      const results = [];
      this.galleryData.images.forEach((image) => {
        results.push(image.sizes.large);
      });
      return results;
    },
    hasSidebar() {
      let result = true;
      if (!this.galleryData.vr && this.galleryData.images.length === 1) {
        result = false;
      }
      return result;
    },
    hasMoreImages() {
      let result = false;
      if (this.galleryData.vr && this.galleryData.images.length > 3) {
        result = this.galleryData.images.length - 3;
      } else if (!this.galleryData.vr && this.galleryData.images.length > 4) {
        result = this.galleryData.images.length - 4;
      }
      return result;
    },
  },
  mounted() {
    new LazyLoad({
      elements_selector: ".lazy",
      unobserve_entered: true,
    });
  },
  methods: {},
};
</script>

<style>
.cool-lightbox .cool-lightbox-button > .cool-lightbox-button__icon {
  padding: 0px !important;
}
</style>
